import { Box, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { getAllRegions, getDashboardArea } from "../../api/area";
import { getStaticAccesses, myCartableAreas } from "../../api/jahadgar";
import CalendarIcon from "../../assets/SVG/calendarIcon";
import ClockIcon from "../../assets/SVG/clockIcon";
import EditEreaIcon from "../../assets/SVG/editEreaIcon";
import FlagIcon from "../../assets/SVG/flagIcon";
import NotePage from "../../pages/leaderGroup/notePage";
import CreateAreaPop from "./createAreaPop.jsx/createAreaPop";
import DashboardArea2 from "./dashboardArea2";
import TablePresence from "./table/tablePresence";

export default function DashboardArea({
  data,
  setData,
  role,
  setSidebarAreaData,
}) {
  const [selected, setSelected] = useState(0);
  // const [data, setData] = useState();
  const [openCreatePop, setOpenCreatePop] = useState();
  const [areaId, setAreaId] = useState();
  const [dataArea, setDataArea] = useState();

console.log(dataArea);
  useEffect(() => {
    if (data) {
      if (data[0]?.areas[0]?.cityId) {
        if (role?.hasActiveRegion) {
          getDashboardArea(data[0]?.areas[0]?.id)
            .then((x) => {
              setDataArea(x);
              setSidebarAreaData(x);
            })
            .catch(() => {});
        }
        if (role?.hasActiveTask) {
          myCartableAreas()
            .then((x) => setDataArea(x))
            .catch(() => {});
        }
      }
    }
  }, [data]);

  // useEffect(() => {
  //   if (data) {
  //     getStaticAccesses(data[0]?.areas[0]?.id)
  //       .then(() => {})
  //       .catch(() => {});
  //   }
  // }, [data]);
  // console.log(role);
  return (
    <>
      {data && (
        <CreateAreaPop
          update={
            (data[0]?.areas[0]?.cityId?.timestamp || data[0]?.areas[0]?.city) &&
            role?.hasActiveRegion
              ? true
              : false
          }
          areaId={areaId || data[0]?.areas[0]?.id}
          anchorEl={openCreatePop}
          setAnchorEl={setOpenCreatePop}
        />
      )}
      <Box display="flex" mt="40px" gap="20px">
        <Typography
          onClick={() => setSelected(0)}
          className={
            selected === 0 ? "styleSelectedTab" : "styleNotSelectedTab"
          }
        >
          {"داشبورد"}
        </Typography>
        {(data[0]?.areas[0]?.cityId?.timestamp || data[0]?.areas[0]?.cityId) &&
          role?.hasActiveRegion && (
            <Typography
              onClick={() => setSelected(2)}
              className={
                selected === 2 ? "styleSelectedTab" : "styleNotSelectedTab"
              }
            >
              {"جهادگران"}
            </Typography>
          )}
        <Typography
          onClick={() => setSelected(1)}
          className={
            selected === 1 ? "styleSelectedTab" : "styleNotSelectedTab"
          }
        >
          {"یادداشت"}
        </Typography>
      </Box>
      {selected === 2 && data && (
        <Box mt="20px">
          <TablePresence areaId={data[0]?.areas[0]?.id} />
        </Box>
      )}
      {selected === 0 && data && role?.hasActiveRegion && (
        <>
          {data[0]?.areas[0]?.cityId?.timestamp || data[0]?.areas[0]?.cityId ? (
            <>
              <Box
                display={"flex"}
                sx={{ cursor: "pointer" }}
                width="fit-content"
                alignItems="center"
                mt="20px"
                onClick={(e) => {
                  setOpenCreatePop(e.currentTarget);
                }}

                // onClick={() => setShowNewNote(true)}
              >
                <EditEreaIcon />
                <Typography color="#4C8395">ویرایش اردو</Typography>
              </Box>
              <DashboardArea2 dataArea={dataArea} data={data} />
            </>
          ) : (
            <Box mt="50px" display="flex" gap="15px">
              {data?.map((x) => (
                <Box
                  //   mt="50px"
                  p="10px"
                  bgcolor="#F5F9FF"
                  borderRadius="12px"
                  width="240px"
                  height="200px"
                  boxShadow={"0px 4px 4px 0px rgba(0, 0, 0, 0.25)"}
                >
                  <Box
                    sx={{
                      overflow: "auto",
                      height: "100%",
                      px: "5px",
                      direction: "ltr",
                      "::-webkit-scrollbar-thumb": {
                        background: "#126E83",
                        // borderRadius: "10px"
                      },
                      "::-webkit-scrollbar-track": {
                        background: "#A7C9D1",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <Box sx={{ direction: "rtl" }}>
                      <Typography
                        fontWeight="bold"
                        color="var(--emr-font)"
                        fontSize={"20px"}
                        mt="15px"
                      >
                        {x.name}
                      </Typography>

                      {x.areas?.length >= 1 &&
                        x.areas?.map((item, index) => (
                          <>
                            <Box
                              sx={{ cursor: "pointer" }}
                              mt={index === 0 ? "20px" : "15px"}
                              display={"flex"}
                            >
                              <FlagIcon color={`var(--emr-${item.color})`} />
                              <Typography
                                mr="8px"
                                fontSize={"14px"}
                                color="#6C6969"
                              >
                                {item.name}
                              </Typography>
                            </Box>
                          </>
                        ))}
                      {x.startAt && (
                        <Box
                          sx={{ cursor: "pointer" }}
                          mt="10px"
                          gap="10px"
                          alignItems={"center"}
                          display={"flex"}
                        >
                          <CalendarIcon />
                          <Typography
                            color="var(--emr-gray)"
                            //   fontSize={"16px"}
                            // mt="10px"
                          >
                            {`${x.startAt?.split(" ", 1)[0]} - ${
                              x.endAt?.split(" ", 1)[0]
                            } `}
                          </Typography>
                        </Box>
                      )}
                      {/* {x.startAt && ( */}
                      <Box
                        sx={{ cursor: "pointer" }}
                        mt="10px"
                        gap="10px"
                        alignItems={"center"}
                        display={"flex"}
                      >
                        <ClockIcon />
                        <Typography
                          color="var(--emr-gray)"
                          //   fontSize={"16px"}
                          // mt="10px"
                        >
                          {`${x.startAt?.split(" ", 3)[2]} - ${
                            x.endAt?.split(" ", 3)[2]
                          } `}
                        </Typography>
                      </Box>
                      <Typography
                        mt="10px"
                        mr="5px"
                        color="var(--emr-darkblue)"
                        fontWeight="bold"
                        sx={{ cursor: "pointer" }}
                        onClick={(e) => {
                          setOpenCreatePop(e.currentTarget);
                          setAreaId(x.areas[0]?.id);
                        }}
                      >
                        + تعریف منطقه
                      </Typography>
                      {/* )} */}
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </>
      )}
      {selected === 1 && <NotePage />}
    </>
  );
}
